/**
 * Div 안에 컨텐츠를 채우는 클래스
 *
 * Div 는 Pop 과 BS 와는 달리 여러개의 target 을 가질수있다.
 *
 * [구조]
 * container (예: MainHub) -> Div -> target (예: F.Docs.Car)
 * 컨테이너가 파괴될때 컨테이너안에 있던 target 들도 파괴되어야한다.
 */
export default class Div {
    constructor() {
        this.list = {};// {id: {id, target, data, container}}
    }

    /**
     * 컨테이너가 파괴될때 컨테이너안에 있던 Div 파생 핸들러도 파괴한다.
     * @param inst 컨테이너인스턴스
     */
    destroyByContainer(inst){
        $.each(this.list, (id, options)=>{
            if( options.container == inst ){
                console.log('destroy',options.target);
                $j.destroy(options.target);
                delete this.list[id];
            }
        });
    }

    /**
     * Div 영역을 연다.
     * @param options
     *      container, // 컨테이너 인스턴스  예) $j.F.Docs.MainHub
     *      id, // div id
     *      target, // 타겟 클래스명 예) F.Docs.Car
     *      data,  // 파라미터
     */
    open(options={}){
        if(!options.id) throw new Error('divId is required');

        // 기존의 영역에 타겟이 존재하였었다면 파괴한다.
        if( this.list[options.id] ) {
            $j.destroy(this.list[options.id].target);
        }

        // 타겟 오브젝트 생성
        const target = $j.reset(options.target);
        if (!target || typeof target !== 'object') {
            throw new Error('Target must be an object');
        }
        this.list[options.id] = options;

        // 타겟 오브젝트에게 제어권을 넘긴다.
        target.id=options.id;
        target.data=options.data;
        target.parent=options.container;
        target.init();
    }

    /**
     * Div 영역을 닫는다.
     */
    close(id=null){
        $.each(this.list, (i,v)=>{
            if( id && id != v.id) return;
            $('#'+v.id).html(''); // 영역을 지운다.
            $j.destroy(v.target);
        });
    }

}